export default __webpack_public_path__ + "static/media/13_temp.ddfd5e49.JPG";